export const C1_PRODUCT_NAME = "Concept One";
export const C1_APP_ICON = "/images/estada-concept-one-icon.svg";
export const C1_APP_LOGO = "/images/estada-concept-one.svg";
export const C1_DOCUMENT_LOGO = "/images/logo-c1-small-2.png";
export const ESTADA_PDF_COVER_LOGO = "/images/logoBig.jpg";
